"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.uniqueClientId = exports.DbConnection = exports.StateListener = exports.Reducer = exports.PresenceListener = exports.HttpConnection = exports.Api = void 0;
var CBOR = __importStar(require("cbor-web"));
var latency_1 = require("./latency");
var api_1 = require("./api");
__createBinding(exports, api_1, "Api");
var http_1 = require("./http");
__createBinding(exports, http_1, "HttpConnection");
var presence_1 = require("./presence");
__createBinding(exports, presence_1, "PresenceListener");
var reducer_1 = require("./reducer");
__createBinding(exports, reducer_1, "Reducer");
var state_1 = require("./state");
__createBinding(exports, state_1, "StateListener");
var CLIENT_ID_KEY = '_driftdb_client_id';
/**
 * A connection to a DriftDB room.
 */
var DbConnection = /** @class */ (function () {
    function DbConnection() {
        this.connection = null;
        this.status = { connected: false };
        this.statusListener = new EventListener();
        this.messageListener = new EventListener();
        this.subscriptions = new SubscriptionManager();
        this.sizeSubscriptions = new SubscriptionManager();
        this.queue = [];
        this.dbUrl = null;
        this.reconnectLoopHandle = null;
        this.activeLatencyTest = null;
        this.cbor = false;
        this.closed = false;
    }
    /**
     * Connect to a DriftDB room.
     * @param dbUrl The URL of the DriftDB room to connect to.
     * @param cbor Whether to use CBOR encoding for messages.
     *
     * @returns A promise that resolves when the connection is established.
     */
    DbConnection.prototype.connect = function (dbUrl, cbor) {
        var _this = this;
        if (cbor === void 0) { cbor = false; }
        if (cbor) {
            dbUrl = dbUrl + '?cbor=true';
        }
        this.dbUrl = dbUrl;
        this.cbor = cbor;
        var resolve;
        var reject;
        var promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        if (this.connection) {
            this.connection.close();
        }
        this.connection = new WebSocket(dbUrl);
        this.connection.binaryType = 'arraybuffer';
        this.connection.onopen = function () {
            if (_this.reconnectLoopHandle) {
                clearInterval(_this.reconnectLoopHandle);
                _this.reconnectLoopHandle = null;
            }
            _this.setStatus(true);
            _this.queue.forEach(function (message) {
                _this.send(message);
            });
            _this.queue = [];
            resolve();
        };
        this.connection.onerror = function (err) {
            if (!_this.closed) {
                _this.setStatus(false);
                reject(err);
            }
        };
        this.connection.onclose = function () {
            _this.setStatus(false);
            console.log('Connection closed, attempting to reconnect...');
            _this.reconnectLoopHandle = setTimeout(function () {
                _this.connect(dbUrl, cbor);
            }, 1000);
        };
        this.connection.onmessage = function (event) {
            var message;
            if (event.data instanceof ArrayBuffer) {
                message = CBOR.decode(event.data);
            }
            else {
                message = JSON.parse(event.data);
            }
            _this.messageListener.dispatch(message);
            switch (message.type) {
                case 'init':
                    var key_1 = message.key;
                    message.data.forEach(function (value) {
                        _this.subscriptions.dispatch(key_1, value);
                    });
                    break;
                case 'push':
                    _this.subscriptions.dispatch(message.key, {
                        seq: message.seq,
                        value: message.value
                    });
                    break;
                case 'stream_size':
                    _this.sizeSubscriptions.dispatch(message.key, message.size);
                    break;
                case 'pong':
                    if (_this.activeLatencyTest) {
                        _this.activeLatencyTest.receivedResponse();
                        _this.activeLatencyTest = null;
                    }
                    break;
                default:
                    console.error('Unknown message type', message.type);
            }
        };
        return promise;
    };
    /**
     * Test the connection latency by sending a ping to the server.
     *
     * @returns A promise that resolves to the latency in milliseconds, or null if the connection is not open.
     */
    DbConnection.prototype.testLatency = function () {
        var _a;
        if (!this.status.connected || ((_a = this.connection) === null || _a === void 0 ? void 0 : _a.readyState) !== WebSocket.OPEN) {
            return null;
        }
        if (!this.activeLatencyTest) {
            this.activeLatencyTest = new latency_1.LatencyTest();
            this.send({ type: 'ping' });
        }
        return this.activeLatencyTest.result();
    };
    /**
     * Get the URL of the DriftDB UI for this connection.
     *
     * @returns The URL of the DriftDB UI, or null if the connection is not open.
     */
    DbConnection.prototype.debugUrl = function () {
        if (!this.dbUrl) {
            return null;
        }
        return "https://ui.driftdb.com/?url=".concat(encodeURIComponent(this.dbUrl));
    };
    /**
     * Close the connection to the DriftDB room.
     */
    DbConnection.prototype.disconnect = function () {
        this.closed = true;
        if (this.connection !== null) {
            this.connection.onclose = null;
            this.connection.onerror = null;
            this.connection.onmessage = null;
            this.connection.onopen = null;
            this.connection.close();
        }
        this.subscriptions = new SubscriptionManager();
        this.sizeSubscriptions = new SubscriptionManager();
    };
    DbConnection.prototype.setStatus = function (connected) {
        this.status = connected ? { connected: true, debugUrl: this.debugUrl() } : { connected: false };
        this.statusListener.dispatch(this.status);
    };
    /**
     * Send a message to the DriftDB server.
     *
     * @param message The message to send.
     */
    DbConnection.prototype.send = function (message) {
        var _a;
        if (!this.status.connected || ((_a = this.connection) === null || _a === void 0 ? void 0 : _a.readyState) !== WebSocket.OPEN) {
            this.queue.push(message);
            return;
        }
        if (this.cbor) {
            this.connection.send(CBOR.encode(message));
        }
        else {
            this.connection.send(JSON.stringify(message));
        }
    };
    /**
     * Subscribe to a key in the DriftDB room.
     *
     * @param key The key to subscribe to.
     * @param listener A callback that will be called whenever a new value is pushed to the key.
     * @param sizeCallback An optional callback that will be called whenever the size of the
     * server's retained stream changes.
     */
    DbConnection.prototype.subscribe = function (key, listener, sizeCallback) {
        this.subscriptions.subscribe(key, listener);
        if (sizeCallback) {
            this.sizeSubscriptions.subscribe(key, sizeCallback);
        }
        this.send({ type: 'get', key: key, seq: 0 });
    };
    /**
     * Unsubscribe from a key in the DriftDB room.
     *
     * @param key The key to unsubscribe from.
     * @param listener The callback that was passed to `subscribe`.
     * @param sizeCallback The callback that was passed to `subscribe`.
     */
    DbConnection.prototype.unsubscribe = function (subject, listener, sizeCallback) {
        this.subscriptions.unsubscribe(subject, listener);
        if (sizeCallback) {
            this.sizeSubscriptions.unsubscribe(subject, sizeCallback);
        }
    };
    return DbConnection;
}());
exports.DbConnection = DbConnection;
/**
 * Generate a random client ID for the current client.
 *
 * The client ID is stored in session storage so that it is the same
 * across page reloads.
 *
 * @returns A random client ID that is stored in session storage.
 */
function uniqueClientId() {
    if (sessionStorage.getItem(CLIENT_ID_KEY)) {
        return sessionStorage.getItem(CLIENT_ID_KEY);
    }
    else {
        var clientId = crypto.randomUUID();
        sessionStorage.setItem(CLIENT_ID_KEY, clientId);
        return clientId;
    }
}
exports.uniqueClientId = uniqueClientId;
var EventListener = /** @class */ (function () {
    function EventListener() {
        this.listeners = [];
    }
    EventListener.prototype.addListener = function (listener) {
        this.listeners.push(listener);
    };
    EventListener.prototype.removeListener = function (listener) {
        this.listeners = this.listeners.filter(function (l) { return l !== listener; });
    };
    EventListener.prototype.dispatch = function (event) {
        this.listeners.forEach(function (l) { return l(event); });
    };
    return EventListener;
}());
var SubscriptionManager = /** @class */ (function () {
    function SubscriptionManager() {
        this.subscriptions = new Map();
    }
    SubscriptionManager.prototype.subscribe = function (key, listener) {
        if (!this.subscriptions.has(key)) {
            this.subscriptions.set(key, new EventListener());
        }
        var subscription = this.subscriptions.get(key);
        subscription.addListener(listener);
    };
    SubscriptionManager.prototype.unsubscribe = function (subject, listener) {
        var key = JSON.stringify(subject);
        if (!this.subscriptions.has(key)) {
            return;
        }
        var subscription = this.subscriptions.get(key);
        subscription.removeListener(listener);
    };
    SubscriptionManager.prototype.dispatch = function (key, event) {
        if (!this.subscriptions.has(key)) {
            return;
        }
        var subscription = this.subscriptions.get(key);
        subscription.dispatch(event);
    };
    return SubscriptionManager;
}());
